import { useCallback } from "react";
import { useAppDispatch } from "../hooks";
import { photoCrud } from "../slices/photoSlice";

interface PhotoCrudProps {
  method: string;
  data: any;
  id: number | null;
}

export const usePhotoRequest = () => {
  const dispatch = useAppDispatch();

  const photoRequest = useCallback(async ({ method, data, id }: PhotoCrudProps): Promise<any> => {
    const dispatchData = await dispatch(photoCrud({ method, data, id }));
    return dispatchData;
  }, [dispatch]);

  return photoRequest;
};
